import { Component } from '@angular/core';

@Component({
  selector: 'novus-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'novus-web';
}
